import { render, staticRenderFns } from "./WasWirFuerSieTunKoennen.vue?vue&type=template&id=17b98d7a&scoped=true&"
import script from "./WasWirFuerSieTunKoennen.vue?vue&type=script&lang=js&"
export * from "./WasWirFuerSieTunKoennen.vue?vue&type=script&lang=js&"
import style0 from "./WasWirFuerSieTunKoennen.vue?vue&type=style&index=0&id=17b98d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b98d7a",
  null
  
)

export default component.exports